export const getVimeoIFrame = (vimeoId) => {
    return `
        <iframe
            src="https://player.vimeo.com/video/${vimeoId}?autoplay=1&controls=1&loop=0&autopause=0&title=0&portrait=0&byline=0&vimeo_logo=0&colors=230013,E90112,F0F0F0,230013"
            frameborder="0"
            allow="autoplay; fullscreen"
            allowfullscreen
        ></iframe>
    `;
}
